/** Why an operator-management write happened — the closed vocabulary the server accepts. */
export const OPERATOR_ACTION_REASON_CODES = [
    'operator_onboarding',
    'operator_role_change',
    'operator_temporary_coverage',
    'operator_offboarding',
    'operator_security_incident',
    'operator_lost_device',
    'operator_policy_violation',
    'operator_other',
];
const reasonBody = (r) => ({ reasonCode: r.reasonCode, ...(r.note !== undefined && r.note.trim() !== '' ? { note: r.note.trim() } : {}) });
const enc = encodeURIComponent;
export class OperatorsAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(country) {
        const qs = country !== undefined ? `?country=${enc(country)}` : '';
        return this.client.request({ method: 'GET', path: `/v1/admin/operators${qs}`, auth: true });
    }
    get(userId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/operators/${enc(userId)}`, auth: true });
    }
    audit(userId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/operators/${enc(userId)}/audit`, auth: true });
    }
    invite(input) {
        const { reasonCode, note, ...rest } = input;
        const body = { ...rest, ...reasonBody({ reasonCode, ...(note !== undefined ? { note } : {}) }) };
        return this.client.request({ method: 'POST', path: '/v1/admin/operators', body, auth: true });
    }
    reissueInvitation(userId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/admin/operators/${enc(userId)}/invitation`, body: reasonBody(reason), auth: true });
    }
    /** 201 `{ grant, fourEyes: false }` for a non-admin role; 202 `{ request, fourEyes: true }` for an admin role. */
    grant(userId, input) {
        const { reasonCode, note, ...rest } = input;
        const body = { ...rest, ...reasonBody({ reasonCode, ...(note !== undefined ? { note } : {}) }) };
        return this.client.request({ method: 'POST', path: `/v1/admin/operators/${enc(userId)}/grants`, body, auth: true });
    }
    revokeGrant(userId, grantId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/admin/operators/${enc(userId)}/grants/${enc(grantId)}/revoke`, body: reasonBody(reason), auth: true });
    }
    /** The four-eyes queue of admin-role requests the reader may decide (`operator:approve`). */
    grantRequests() {
        return this.client.request({ method: 'GET', path: '/v1/admin/operator-grant-requests', auth: true });
    }
    /** approve / reject (a DIFFERENT operator; a rejection says why) or withdraw (the proposer). */
    decideGrantRequest(requestId, action, note) {
        const body = note !== undefined && note.trim() !== '' ? { note: note.trim() } : {};
        return this.client.request({ method: 'POST', path: `/v1/admin/operator-grant-requests/${enc(requestId)}/${action}`, body, auth: true });
    }
    deactivate(userId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/admin/operators/${enc(userId)}/deactivate`, body: reasonBody(reason), auth: true });
    }
    reactivate(userId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/admin/operators/${enc(userId)}/reactivate`, body: reasonBody(reason), auth: true });
    }
    revokeSessions(userId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/admin/operators/${enc(userId)}/sessions/revoke`, body: reasonBody(reason), auth: true });
    }
    resetMfa(userId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/admin/operators/${enc(userId)}/mfa/reset`, body: reasonBody(reason), auth: true });
    }
}
//# sourceMappingURL=operators-admin.js.map